






















































































import { Component, Vue } from 'vue-property-decorator'
import HeaderNavigationDropdown from '@/components/layout/header/navigation/HeaderNavigationDropdown.vue'
import RouteName from '@/utils/RouteName'
import TranslationModule from '@/utils/TranslationModule'
import HeaderNavigationItemTitle from '@/components/layout/header/navigation/HeaderNavigationItemTitle.vue'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

@Component({
    components: { EvaIcon, HeaderNavigationItemTitle, HeaderNavigationDropdown, BaseIcon },
})
export default class HeaderMoreNavigation extends Vue {
    RouteName: typeof RouteName = RouteName
    TranslationModule: typeof TranslationModule = TranslationModule

    workspaces = [
        { name: 'New York', location: 'New York' },
        { name: 'Paris', location: 'Paris' },
        { name: 'Londres', location: 'Londres' },
        { name: 'Madrid', location: 'Madrid' },
        { name: 'Hong Kong', location: 'The Great Room' },
    ]
    benefits = ['Business', 'Hotel', 'Travel', 'Lifestyle']
}
